import React, { useEffect, useState } from 'react';
import './QuadView.css';

interface QuadViewProps {
  PeakImages: any[];
  RestImages: any[];
  currQuadIdx: number;
  onCurrQuadIdxChange: (idx: number) => void;
}

const QuadView = ({ PeakImages, RestImages, currQuadIdx, onCurrQuadIdxChange }: QuadViewProps) => {
  const [quadViewArray, setQuadViewArray] = useState([]);
  const [inArrIdxs, setInArrIdxs] = useState([0, 0, 0, 0]);

  function updateViews(data) {
    const viewMapping = {
      '4CH': 'AP4',
      '2CH': 'AP2',
      APLAX: 'AP3',
      PLAX: 'LAX',
      'SAX-PM': 'SAX',
      ASX: 'pSAX-ap1',
    };

    return data.map(item => ({
      ...item,
      view: viewMapping[item.view] || item.view,
    }));
  }

  function groupImagesByView(restImages, peakImages) {
    const viewGroups = [
      ['AP4', 'AP2'],
      ['LAX', 'SAX'],
      ['AP3', 'pSAX-ap1'],
    ];

    const result = [];

    for (const group of viewGroups) {
      const groupResult = [];
      let isEmptyGroup = true;

      for (const view of group) {
        const restView = restImages.filter(image => image.view === view);
        const peakView = peakImages.filter(image => image.view === view);

        groupResult.push(restView, peakView);

        if (restView.length > 0 || peakView.length > 0) {
          isEmptyGroup = false;
        }
      }

      if (!isEmptyGroup) {
        result.push(groupResult);
      }
    }

    return result;
  }

  const handleNavClick = action => {
    if (action === 'next' && currQuadIdx < quadViewArray?.length - 1) {
      onCurrQuadIdxChange(currQuadIdx + 1);
    } else if (action === 'prev' && currQuadIdx > 0) {
      onCurrQuadIdxChange(currQuadIdx - 1);
    }
    setInArrIdxs([0, 0, 0, 0]);
  };

  const handleInnerNavClick = (position, command) => {
    setInArrIdxs(curr => {
      const newIdxs = [...curr];
      if (
        command === 'next' &&
        newIdxs[position] < quadViewArray?.[currQuadIdx]?.[position]?.length - 1
      ) {
        newIdxs[position]++;
      } else if (command === 'prev' && newIdxs[position] > 0) {
        newIdxs[position]--;
      }
      return newIdxs;
    });
  };

  useEffect(() => {
    const _restImages = updateViews(RestImages);
    const _peakImages = updateViews(PeakImages);
    const _quadViewArray = groupImagesByView(_restImages, _peakImages);
    setQuadViewArray(_quadViewArray);
  }, [PeakImages, RestImages]);

  useEffect(() => {
    setInArrIdxs([0, 0, 0, 0]);
  }, [currQuadIdx]);

  if (quadViewArray?.length === 0) {
    return <p className="w-full text-center">No media found</p>;
  }

  return (
    <div className="quad_view_mode">
      <div className="quad_nav_btn">
        <button onClick={() => handleNavClick('prev')}>{'<'}</button>
      </div>
      <div className="quad_wrapper">
        <div className="quad_row">
          {[quadViewArray?.[currQuadIdx]?.[0], quadViewArray?.[currQuadIdx]?.[1]].map(
            (image, index) => (
              <div
                key={index}
                className="quad_element"
              >
                {image?.[inArrIdxs[index]]?.mediaUrl?.endsWith('.webm') ? (
                  <video
                    key={image?.[inArrIdxs[index]]?.mediaUrl}
                    className="quad_media"
                    autoPlay
                    controls
                    loop
                    disablePictureInPicture
                    controlsList="nofullscreen"
                  >
                    <source
                      src={image?.[inArrIdxs[index]]?.mediaUrl}
                      type="video/webm"
                    />
                    Your browser does not support video.
                  </video>
                ) : (
                  <img
                    src={image?.[inArrIdxs[index]]?.mediaUrl}
                    alt={`Media ${index}`}
                    className="quad_media"
                  />
                )}
                {/* <div className="quad_media-info">
                  {image?.[inArrIdxs[index]]?.stage} - {image?.[inArrIdxs[index]]?.view}
                </div> */}
                <div className="quad_media-nav quad_media-nav-next">
                  <button
                    className="quad_media-nav-btn"
                    onClick={() => handleInnerNavClick(index, 'next')}
                  >
                    {'>'}
                  </button>
                </div>
                <div className="quad_media-nav quad_media-nav-prev">
                  <button
                    className="quad_media-nav-btn"
                    onClick={() => handleInnerNavClick(index, 'prev')}
                  >
                    {'<'}
                  </button>
                </div>
              </div>
            )
          )}
        </div>
        <div className="quad_row">
          {[quadViewArray?.[currQuadIdx]?.[2], quadViewArray?.[currQuadIdx]?.[3]].map(
            (image, index) => (
              <div
                key={index + 2}
                className="quad_element"
              >
                {image?.[inArrIdxs[index + 2]]?.mediaUrl?.endsWith('.webm') ? (
                  <video
                    key={image?.[inArrIdxs[index + 2]]?.mediaUrl}
                    className="quad_media"
                    autoPlay
                    controls
                    loop
                    disablePictureInPicture
                    controlsList="nofullscreen"
                  >
                    <source
                      src={image?.[inArrIdxs[index + 2]]?.mediaUrl}
                      type="video/webm"
                    />
                    Your browser does not support video.
                  </video>
                ) : (
                  <img
                    src={image?.[inArrIdxs[index + 2]]?.mediaUrl}
                    alt={`Media ${index + 2}`}
                    className="quad_media"
                  />
                )}
                {/* <div className="quad_media-info">
                  {image?.[inArrIdxs[index + 2]]?.stage} - {image?.[inArrIdxs[index + 2]]?.view}
                </div> */}
                <div className="quad_media-nav quad_media-nav-next">
                  <button
                    className="quad_media-nav-btn"
                    onClick={() => handleInnerNavClick(index + 2, 'next')}
                  >
                    {'>'}
                  </button>
                </div>
                <div className="quad_media-nav quad_media-nav-prev">
                  <button
                    className="quad_media-nav-btn"
                    onClick={() => handleInnerNavClick(index + 2, 'prev')}
                  >
                    {'<'}
                  </button>
                </div>
              </div>
            )
          )}
        </div>
      </div>
      <div className="quad_nav_btn">
        <button onClick={() => handleNavClick('next')}>{'>'}</button>
      </div>
    </div>
  );
};

export default QuadView;
